import { SupportedCategoryIds } from "@/services/aiIdentification";
import type { CategoryId } from "@/services/collection/categories";
import { isValidCategoryId } from "@/services/collection/categories/categoriesHelpers";
import { IndexedDb, IndexedDbKey } from "@/services/indexedDb";
import { readonly } from "vue";

const id = ref<CategoryId | undefined>();

let initPromise: Promise<void> | null = null;

export function useLastAiCategory() {
  if (initPromise === null) {
    initPromise = IndexedDb.get(IndexedDbKey.AiLastCategoryId).then((value) => {
      if (isValidCategoryId(value) && SupportedCategoryIds.includes(value)) {
        id.value = value;
      } else {
        id.value = undefined;
      }
    });
  }

  const set = async (categoryId: CategoryId) => {
    if (SupportedCategoryIds.includes(categoryId)) {
      await initPromise;
      id.value = categoryId;
      return IndexedDb.set(IndexedDbKey.AiLastCategoryId, categoryId);
    } else {
      // Quietly ignore invalid category (we dropped support for some of them)
    }
  };

  return {
    id: readonly(id),
    set,
  };
}
